<template>
    <div id="monitor_option"
        class="option-select"
    >
        <v-select 
            v-model="current_option_value" 
            :items="options" 
            hide-details
        />
        {{ description }}
    </div>
</template>

<script>
    export default {
        name: 'MonitorOption',

        props: {
            // 預設選項
            current_option: {
                type: String,
                default() {
                    return ''
                }  
            },
            // 有什麼選項可以選擇
            options: {
                type: Array,
                default() {
                    return []
                }
            },
            // 當作回傳 filter_condition 的 key 
            label: {
                type: String,
                default() {
                    return ''
                }
            },
            // 作為選項補充文字附屬在選項下方
            description: {
                type: String,
                default() {
                    return ''
                }
            }
        },

        data: function() {
            return {
                current_option_value: '',
            }
        },
        
        watch: {
            // 將這個選項目前的值回傳給 monitor_option_set
            current_option_value: function(value){
                this.$emit('change_filter_option_value', this.label, value);
            }
        },

        created: function() {
            // 這是由於不能修改 props 的關係
            this.current_option_value = this.current_option;
        },

        updated: function() {
            this.current_option_value = this.current_option;
        },
    }
</script>

<style lang="scss" scoped>
    .option-select {
        margin: 0 16px 0 0;
        max-width: 9rem;

        ::v-deep .v-select__selection--comma {
            margin: 7px 4px 3px 0;
            max-width: 100%;
            line-height: 1.3;
        }
    }
</style>

<style scoped>
    #monitor_option >>> .v-select__selection {
        font-size: 14px;
        height: 20px;
    }

    #monitor_option >>> .v-select__selections input{
        display: none;
    }
</style>
